module.exports = __webpack_public_path__ + "img/formulaone-dark.92b32a78.svg";